export * as Api from './api';
export * as Schema from './schema';
export var InvestorCertificationQuestionType;
(function (InvestorCertificationQuestionType) {
    InvestorCertificationQuestionType["Checkbox"] = "CHECKBOX";
    InvestorCertificationQuestionType["Radio"] = "RADIO";
    InvestorCertificationQuestionType["Text"] = "TEXT";
})(InvestorCertificationQuestionType || (InvestorCertificationQuestionType = {}));
//# sourceMappingURL=index.js.map